<template>
  <div class="page-container">
    <el-row>
      <el-col class="container-right">
        <div class="searchconditions">
          <el-form :model="searchForm" ref="searchForm" inline>
            <el-form-item prop="name" label="按钮名称">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="cyan" @click="handleSearch"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              class="add-button"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增按钮</el-button
            >
          </el-col>
        </el-row>
        <el-table :data="dataList" style="width: 100%" v-loading="loading">
          <el-table-column
            prop="name"
            label="按钮名称"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="code"
            label="按钮编码"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-switch
                v-if="scope.row.isMain !== 1"
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            class="handle-btn"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isMain !== 1"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, sizes, total, jumper"
          :page-sizes="[10, 15, 20]"
          :page-size="pageSize"
          :total="total"
          :current-page="listForm.pageNum"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleClose" 
      
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="按钮名称" prop="name">
          <el-input v-model="form.name" placeholder="输入按钮名称"></el-input>
        </el-form-item>
        <el-form-item label="按钮编码" prop="code">
          <el-input v-model="form.code" placeholder="输入按钮编码"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="saveAddOrEdit()">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryMenuBtnList,
  saveOrEditMenuBtn,
  updateMenuStatus,
} from "@/common/api.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      tags: [],
      dialogVisible: false,
      loading: false,
      // 员工列表
      dataList: [],
      total: 0,
      pageSize: 10,
      currpage: 1,
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        name: [{ required: true, message: "请输入按钮名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入别名", trigger: "blur" }],
      },
      //新增、编辑
      form: {
        name: "",
        code: "",
        remark: "",
      },
      // 查询
      searchForm: {
        name: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 按钮列表
    queryMenuBtnList() {
      this.loading = true;
      var params = {
        pageSize: this.pageSize,
        pagenum: this.currpage,
        data: {},
      };
      queryMenuBtnList(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增按钮
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增按钮";
    },
    // 编辑按钮
    edit(row) {
      console.log(row);
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑按钮";
      this.form = {
        id: row.id,
        name: row.name,
        code: row.code,
        remark: row.remark,
      };
    },
    // 新增或编辑保存
    saveAddOrEdit() {
      console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveOrEditMenuBtn(this.form).then((res) => {
            if (res.errorCode == "200") {
              this.queryMenuBtnList();
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "保存成功",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    //变更状态
    statusChange(row) {
      console.log(row);
      var department = row.name;
      var mess = "";
      let text = "";
      if (row.status == 1) {
        text = "启用";
      } else if (row.status == 0) {
        text = "禁用";
        // mess = "设置为无效后，该人员将无法登录平台";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否 "' + text + '" 按钮 "' + department + '" ?',
            "警告"
          ),
          h("h6", { style: "color:#a0a0a0" }, mess),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              id: row.id,
              status: row.status,
            };
            updateMenuStatus(params).then((res) => {
              if (res.errorCode == "200") {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 表单数据清空
    reset() {
      this.form = {
        name: "",
        code: null,
        remark: "",
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    //选页
    handleCurrentChange(cpage) {
      this.currpage = cpage;
      this.queryMenuBtnList();
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
      this.queryMenuBtnList();
    },
    // 查询
    handleSearch() {},
  },
  created() {},
  mounted() {
    this.queryMenuBtnList();
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .el-row {
    height: 100%;
  }
  .add-config {
    margin-left: 15px;
    margin-top: 3px;
  }
  .el-tag {
    margin-left: 10px;
  }
  .container-left {
    padding: 0 10px;
    background-color: #fff;
    height: 100%;
    width: 15%;
    .container-title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #eee;
      .el-icon-arrow-down {
        margin-left: 15px;
        font-weight: 800;
      }
      .expand-btn {
        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-left: 5px;
          transform: rotate(0deg);
          transition: transform 0.5s;
        }
        .active {
          transform: rotate(180deg);
          transition: transform 0.5s;
        }
      }
    }
  }
  .container-right {
    padding: 5px 10px 12px;
    border-radius: 6px;
    background-color: #fff;
    margin-top: 10px;
    // margin-left: 12px;
    // width: calc(84% - 20px);
    .add-button {
      margin: 20px 0 10px 10px;
    }
    .searchconditions {
      background: #fff;
      border-radius: 6px;
      margin-top: 10px;
      padding: 5px 15px 12px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
      .el-form {
        .el-form-item {
          display: inline-block;
          margin-right: 10px;
          vertical-align: top;
          margin: 5px 15px 5px 0px;
          /deep/.el-button {
            padding: 8px 15px;
            font-size: 12px;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .select-role {
    height: 60px;
  }
  .person-info {
    margin-bottom: 20px;
    span {
      font-size: 16px;
      font-weight: 600;
    }
    span:nth-child(2) {
      margin-left: 20px;
    }
  }
  .el-row {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
  }
  /deep/.el-input__inner,
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }
  .tree-list {
    font-size: 14px;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/menuManage/buttonsManage.vue